module.exports = __webpack_public_path__ + "static/img/down_bg.3a1ef270.png";